import React from "react";

/*eslint-disable */

declare const window: any;
const TitleComponent: React.FC = () => {
  return (
    <h1 className="title-politicas-component">Políticas de la página</h1>
  );
};

export default TitleComponent;
